import axios from 'axios';

const STORAGE_KEY = 'guard.auth.token';

export const http = axios.create({
  baseURL: '/api',
  timeout: 10_000,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem(STORAGE_KEY);
  if (token) {
    config.headers = config.headers ?? {};
    (config.headers as Record<string, string>).Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      localStorage.removeItem(STORAGE_KEY);
      const path = window.location.pathname;
      if (!path.startsWith('/login') && !path.startsWith('/setup/')) {
        window.location.assign('/login');
      }
    }
    return Promise.reject(err);
  },
);
